import React, { Component } from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

import collectionChangeHandler from '../../helpers/collection-change-handler'

import {
  CollectionButton
} from '../buttons'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

class WorkTrackerFilterModal extends Component {
  renderResourceType () {
    const { resourceType } = this.props
    const resourceComponent = null

    if (resourceType === 'radio') {
      return this.radioButtons()
    }

    if (resourceType === 'checkbox') {
      return this.checkboxes()
    }

    return this.radioButtons()
  }

  radioButtons () {
    const {
      fields: {
        resourceId
      },
      resources,
      resourceNameGenerator
    } = this.props

    return (
      <div>
        {resources.map((resource) => (
          <label key={resource.id}>
            <input
              type='radio'
              {...resourceId}
              value={resource.id}
              checked={
                resourceId.value &&
                  resourceId.value.toString() === resource.id.toString()
              }
            />
            <span className='indicator' />
            {formatResourceName(resource, resourceNameGenerator)}
          </label>
        ))}
      </div>
    )
  }

  checkboxes () {
    const {
      fields: {
        resourceId
      },
      resources,
      resourceNameGenerator
    } = this.props

    return (
      <div>
        {resources.map((resource, index) => {
          return (
            <label htmlFor={resource.id} key={resource.id}>
              <input
                type='checkbox'
                value={resource.id}
                id={resource.id}
                checked={(resourceId.value && resourceId.value.indexOf(resource.id) >= 0)}
                onChange={collectionChangeHandler(resourceId)}
              />
              <span className='indicator' />
              {formatResourceName(resource, resourceNameGenerator)}
            </label>
          )
        })}
      </div>
    )
  }

  render () {
    const {
      fields: {
        image,
        status,
        description,
        resourceId
      },

      resourceType = 'radio',
      resources,
      resourceName,
      resourceNameGenerator,

      handleSubmit,
      handleClose,
      modalTitle,
      submitButtonText,

      hasNextPage,
      onLoadNextPage
    } = this.props

    return (
      <BaseModal
        onClose={handleClose}
        title={modalTitle}
        constraints={constraints}
        contentClassName='work-orders-create-container'
      >
        <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
          <ModalFormRow>
            <ModalFormBlock customClassName="overflowable">
              <CheckboxGroup title={resourceName}>
                {resources && this.renderResourceType(resourceType)}
                {resources.length === 0 &&
                  <p className='none'>No {resourceName}s found for this location.</p>}
              </CheckboxGroup>
            </ModalFormBlock>

          </ModalFormRow>

          {hasNextPage &&
            <CollectionButton className="enabled" onClick={onLoadNextPage}>See more {resourceName}s...</CollectionButton>}

          <ModalFormRow>
            <ModalFormBlock submitButton>
              <button type='submit'>{submitButtonText || 'Submit'}</button>
            </ModalFormBlock>
          </ModalFormRow>
        </ModalForm>
      </BaseModal>
    )
  }
}

function formatResourceName (resource, resourceNameGenerator) {
  if (resourceNameGenerator) {
    return resourceNameGenerator(resource)
  } else {
    return resource.name
  }
}

export default WorkTrackerFilterModal



// WEBPACK FOOTER //
// ./src/components/work-trackers/work-tracker-filter-modal.js